import { TRACKERS } from "@/constants/Trackers";
import { SurgicalHistory } from "@/features/Patient/MedicalRecords/SurgicalHistory/SurgicalHistory";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/surgical-history")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_SURGICAL_HISTORY);
  },
});

function RouteComponent() {
  return <SurgicalHistory />;
}
